// extracted by mini-css-extract-plugin
export default {"header":"TopicActivitiesPanel-module__header--LunU6","content":"TopicActivitiesPanel-module__content--PT5Zt"};